import { default as BroadcastClient } from './broadcast-client';

export default {
  install(Vue) {
    Vue.prototype.$broadcastClient = BroadcastClient;
  },
};
